export const EDIT_RECORD = 'EDIT_RECORD';
export const EMPTY_RECORD = 'EMPTY_RECORD';

export const setEditRecord = record => ({
  type: EDIT_RECORD,
  payload: {
    record,
  },
});

export const emptyEditRecord = () => ({
  type: EMPTY_RECORD,
});
